import { render } from "./About.vue?vue&type=template&id=c2b27afa&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=c2b27afa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\campinasredesdeprotecao\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b27afa"]])

export default __exports__